import { useEffect } from 'react';
import { Advantages } from '../components/Advantages';
import LandingPicture from '../components/LandingPicture';
import ContactForm from '../components/ContactForm';
import RegionalProducts from '../components/RegionalProducts';
import News from '../components/News';
const Home = () => {
  useEffect(() => {
    document.title = 'Kwiecińscy - Zakład Mięsny';
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="home-section">
      <LandingPicture />
      <News />
      <Advantages />
      <RegionalProducts />
      <ContactForm />
    </section>
  );
};

export default Home;
